import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';
import { BookingItemStatusEnum } from '@sport-activities/sdk';
import { Observable } from 'rxjs';

import { OrganizerSharedActivityService } from '~/organizer/shared/services/activity/activity.service';
import { BookingItemsGroupByUserIdInterface } from '~/organizer/shared/services/activity/interfaces/booking-items-group-by-user-id.interface';

export const OrganizerSharedTimeslotParticipantListResolver: ResolveFn<
  BookingItemsGroupByUserIdInterface[]
> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  activityService: OrganizerSharedActivityService = inject(
    OrganizerSharedActivityService
  )
): Observable<BookingItemsGroupByUserIdInterface[]> => {
  const timeslotId = route.paramMap.get('id');

  return activityService.getTimeslotBookingItemsGroupByUserId(
    timeslotId,
    'COMPLETED' as BookingItemStatusEnum
  );
};
